module.exports = __webpack_public_path__ + "static/media/customizacion.15f77a45.png";